module.exports = __webpack_public_path__ + "img/tel-icon.502ded20.png";